export const isOwnerWorkspaceTheme = value => value === 'modern' || value === 'classic';

// Missing preferences on older accounts use the default owner workspace.
export const normalizeOwnerWorkspaceTheme = value => value === 'classic' ? 'classic' : 'modern';
